import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NavigationEnd, Router } from '@angular/router';
import { VaultStoreEffects } from '@app/root-store/vault-store/effects';
import { FolderType } from '@app/shared/models/folder-type.model';
import { InboxSettingsService } from '@app/shared/services/settings/inbox-settings/inbox-settings.service';
import { Subscription } from 'rxjs';
import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';

@AutoUnsubscribe()
@Component({
  selector: 'add-folder-dialog-with-vault',
  templateUrl: './add-folder-dialog-with-vault.component.html',
  styleUrl: './add-folder-dialog-with-vault.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddFolderDialogWithVaultComponent implements OnInit, OnDestroy {
  url;
  vaultId;
  vaultUserId;
  noOfLevel: number = 0;
  isLoading: boolean = false;
  vaults_list = [];
  movingGroup: boolean = false;

  showVault = true;
  defaultCategories: any[] = [];
  subscription = new Subscription();

  folderVaultList: FolderType[] = [];
  recentTopLevelIds: number[] = [];
  categoryFolderId: number = 0;
  searchText = '';

  constructor(
    private _dialogRef: MatDialogRef<AddFolderDialogWithVaultComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    private router: Router,
    private _vaultService: VaultStoreEffects,
    private _inboxService: InboxSettingsService,
    private _cd: ChangeDetectorRef
  ) {
    this.subscription.add(
      this.router.events.subscribe((event) => {
        if (event instanceof NavigationEnd) {
          this.url = event.urlAfterRedirects.split('/');
        }
      })
    );
    this.subscription.add(
      this._vaultService.vaultObject.subscribe((item) => {
        this.vaultUserId = item?.userId;
        this.vaults_list = item.vaults;
        this.vaultId = item?.vaultId ? item?.vaultId : 0;
        this.defaultCategories = item?.categories;
        // let vaultContainer = item?.vaults.find((x: any) => x.id == (this.url[2] == 0 ? null : this.url[2]));
      })
    );
  }

  ngOnInit(): void {
    this.movingGroup = this.data.movingGroup;
  }
  clearSearchAction() {
    this.searchText = '';
  }
  onInputChange(searchValue: string) {
    this.searchText = searchValue;
  }

  rgbaColor(hex: string, opacity: number): string {
    const bigint = parseInt(hex.replace('#', ''), 16);
    const r = (bigint >> 16) & 255;
    const g = (bigint >> 8) & 255;
    const b = bigint & 255;
    return `rgba(${r},${g},${b},${opacity})`;
  }
  moveFileTOVault(item) {
    this._dialogRef.close({
      confirmation: true,
      vault_id: item?.id ? item?.id : '-1',
      user_id: item?.user_id ? item?.user_id : null,
    });
  }
  closeDialog(): void {
    this._dialogRef.close();
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }
}
